import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M23.667 22.046l-2.121 2.121-9.81-9.81-9.654 9.654-2.093-2.093 9.654-9.654-9.311-9.31L2.454.833l9.31 9.31L20.918.989l2.093 2.093-9.154 9.154z" fillRule="evenodd" /></svg>);